import { BASE_URL } from '../../../../../utils/config.base-url'

export const CAR_BRAND_PREFIX_URL = '/car-brand'
export const URL_ENDPOINT_CAR_BRAND = `${BASE_URL}/car-brand`
